<template>
  <div v-if="createdBy" class="row mt-3">
    <div class="col text-start text-body-secondary">تم إضافة هذا العقار بواسطة: {{ createdBy }}</div>
  </div>
  <div v-if="dataRow && dataRow.deletedAt" class="row mt-3">
    <div class="col">
      <div class="alert alert-warning">هذا العقار تم حذفه بواسطة العميل بتاريخ {{ $shortDate(dataRow.deletedAt) }}</div>
    </div>
  </div>
  <div class="card card-secondary card-outline mb-4 mt-4">
    <!--begin::Header-->
    <div class="card-header"><div class="card-title">{{ cardTitle }}</div></div>
    <!--end::Header-->
    <!--begin::Form-->
    <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
    <successAlert v-if="hasSucess" :message="message" />

    <mainLoader v-if="mainLoading" />
    <form v-else @submit.prevent="subimtData()">
      <!--begin::Body-->
      <div class="card-body">
        <div class="row steps-container">
          <div class="col" v-for="(title, index) in stepTitles" :key="index">
            <div class="steps" @click="jumbToStep(index + 1)">
              <span :class="{ active: step === index + 1 }">
                {{ title }}
              </span>
            </div>
          </div>
        </div>
        <!-- owner type -->
        <div v-if="step == 1">
          <div class="mb-3">
            <div class="row">
              <div class="col-12 col-sm-6">
                <label class="form-label" for="">العميل: <span class="req">*</span></label>
                <input type="text" class="form-control" placeholder="جوال العميل" @keyup="getClientData()" v-model="userMobile">
              </div>
              <div class="col-12 col-sm-6">
                <loader v-if="userLoader" />
                <div v-if="userName">
                  <label class="form-label" for="">اسم العميل:</label>
                  <div>{{ userName }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="mb-3">
            <div class="row">
              <div class="col-12 col-sm-6">
                <label class="form-label" for="">الاسم: <span class="req">*</span></label>
                <input type="text" v-model="name" class="form-control" placeholder="الاسم">
              </div>
              <div class="col-12 col-sm-6">
                <label class="form-label" for="">الجوال: <span class="req">*</span></label>
                <input type="text" v-model="mobile" class="form-control" placeholder="الجوال">
              </div>
            </div>
          </div>
          <div class="mb-3">
            <div class="row">
              <div class="col-12 col-sm-6">
                <label class="form-label" for="">البريد الإلكتروني:</label>
                <input type="text" v-model="email" class="form-control" placeholder="البريد الإلكتروني">
              </div>
            </div>
          </div>
        </div>
        <!-- property data -->
        <div v-if="step == 2">
          <div class="row">
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">نوع النشاط التجاري: <span class="req">*</span></label>
              <select class="form-control" ref="businessSelect" v-model="businessId">
                <option :value="null">غير محدد</option>
                <option v-for="row in businessList" :value="row.id" :key="row.id">{{ row.name }}</option>
              </select>
            </div>
            <div v-if="businessOther && businessOther.id == businessId" class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">اسم النشاط التجاري:</label>
              <input type="text" v-model="businessName" class="form-control">
            </div>
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">مساحة المشروع:</label>
              <input type="number" v-model="area" class="form-control">
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">وصف مختصر للمشروع: <span class="req">*</span></label>
              <textarea v-model="description" class="form-control" rows="5"></textarea>
            </div>
            <div class="col-12 col-sm-6 mb-3" v-if="dataRow">
              <label class="form-label">وصف مختصر للمشروع (مترجمة):</label>
              <div class="form-control">{{ descriptionEn }}</div>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">قيمة الإيجار السنوي:</label>
              <input type="number" class="form-control" v-model="rentPrice">
            </div>
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">مدة عقد الإيجار المتبقة: <span class="req">*</span></label>
              <select class="form-control" ref="ageSelect" v-model="ageId">
                <option :value="null">غير محدد</option>
                <option v-for="row in ageList" :value="row.id" :key="row.id">{{ row.name }}</option>
              </select>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">عدد العمالة:</label>
              <input type="number" class="form-control" v-model="workersCount">
            </div>
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">سبب التقبيل: <span class="req">*</span></label>
              <select class="form-control" ref="reasonSelect" v-model="reasonId">
                <option :value="null">غير محدد</option>
                <option v-for="row in reasonList" :value="row.id" :key="row.id">{{ row.name }}</option>
              </select>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">المنطقة: <span class="req">*</span></label>
              <select class="form-control" v-model="regionId" @change="getCitiesList()">
                <option :value="null">غير محدد</option>
                <option v-for="(row, index) in regionsList" :value="row.id" :key="index">{{ row.name }}</option>
              </select>
            </div>
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">المدينة: <span class="req">*</span></label>
              <select class="form-control" ref="citySelect" v-model="cityId" @change="getNeighborhoodsList()">
                <option :value="null">غير محدد</option>
                <option v-for="(row, index) in citiesList" :value="row.id" :key="index">{{ row.name }}</option>
              </select>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">الحي: <span class="req">*</span></label>
              <select class="form-control" ref="neighborhoodSelect" v-model="neighborhoodId">
                <option :value="null">غير محدد</option>
                <option v-for="(row, index) in neighborhoodsList" :value="row.id" :key="index">{{ row.name }}</option>
              </select>
            </div>
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">الموقع على الخريطة:</label>
              <div ref="myMap" style="width: 100%; height: 350px;"></div>
              <div class="row pt-2">
                <div class="col">
                  <label for="" class="form-label">خط العرض - latitude</label>
                  <input type="number" class="form-control" step="0.000001" v-model="latitude" placeholder="latitude" @change="changeMarker()">
                </div>
                <div class="col">
                  <label for="" class="form-label">خط الطول - longitude</label>
                  <input type="number" class="form-control" step="0.000001" v-model="longitude" placeholder="longitude" @change="changeMarker()">
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">الواجهة: <span class="req">*</span></label>
              <select class="form-control" ref="frontSelect" v-model="frontId">
                <option :value="null">غير محدد</option>
                <option v-for="(row, index) in frontList" :value="row.id" :key="index">{{ row.name }}</option>
              </select>
            </div>
          </div>
          
          <div class="row">
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">الاصول والموجودات:</label>
              <textarea v-model="assetsList" class="form-control" rows="5"></textarea>
            </div>
            <div class="col-12 col-sm-6 mb-3" v-if="dataRow">
              <label class="form-label">الاصول والموجودات (مترجمة):</label>
              <div class="form-control">{{ assetsListEn }}</div>
            </div>
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">حالة الاصول: <span class="req">*</span></label>
              <select class="form-control" v-model="assetId">
                <option :value="null">غير محدد</option>
                <option v-for="row in assetsIdList" :value="row.id" :key="row.id">{{ row.name }}</option>
              </select>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">هل هناك إلتزامات مالية أو ديون؟</label>
              <select class="form-control" v-model="hasDebts">
                <option :value="false">لا</option>
                <option :value="true">نعم</option>
              </select>
            </div>
            <div class="row">
              <div class="col-12 col-sm-6 mb-3">
                <label for="" class="form-label">وضح التفاصيل:</label>
                <textarea v-model="debtsList" class="form-control" rows="5"></textarea>
              </div>
              <div class="col-12 col-sm-6 mb-3" v-if="dataRow">
                <label class="form-label">وضح التفاصيل (مترجمة):</label>
                <div class="form-control">{{ debtsListEn }}</div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <label for="" class="form-label">نقاط قوة المشروع:</label>
            </div>
            <div class="col-12">
              <div class="row">
                <div class="col-auto mb-3" v-for="row in strengthsList" :key="row.id">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" :value="row.id" :id="`strengths_${row.id}`" name="strengths[]" v-model="strengths">
                    <label class="form-check-label" :for="`strengths_${row.id}`">{{ row.name }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <label for="" class="form-label">نقاط ضعف المشروع:</label>
            </div>
            <div class="col-12">
              <div class="row">
                <div class="col-auto mb-3" v-for="row in weaknessList" :key="row.id">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" :value="row.id" :id="`weaknesses_${row.id}`" name="weaknesses[]" v-model="weaknesses">
                    <label class="form-check-label" :for="`weaknesses_${row.id}`">{{ row.name }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">عمر المشروع:</label>
              <select class="form-control" ref="projectAgeSelect" v-model="projectAgeId">
                <option :value="null">غير محدد</option>
                <option v-for="row in ageList" :value="row.id" :key="row.id">{{ row.name }}</option>
              </select>
            </div>
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">عدد المكاتب:</label>
              <input type="number" class="form-control" v-model="officesCount">
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">عدد الغرف:</label>
              <input type="number" class="form-control" v-model="roomsCount">
            </div>
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">عدد الصالات:</label>
              <input type="number" class="form-control" v-model="hallsCount">
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">عدد الفتحات:</label>
              <input type="number" class="form-control" v-model="doorsCount">
            </div>
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">عدد دورات المياة:</label>
              <input type="number" class="form-control" v-model="bathroomsCount">
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">عدد الطوابق (الادوار):</label>
              <input type="number" class="form-control" v-model="floorsCount">
            </div>
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">عدد مواقف السيارت:</label>
              <input type="number" class="form-control" v-model="parkingCount">
            </div>
          </div>
          
          <div class="row">
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">المبلغ المطلوب:</label>
              <input type="number" class="form-control" v-model="price">
            </div>
            <div class="row">
              <div class="col-12 col-sm-6 mb-3">
                <label for="" class="form-label">ملاحظات اخرى:</label>
                <textarea v-model="notices" class="form-control" rows="5"></textarea>
              </div>
              <div class="col-12 col-sm-6 mb-3" v-if="dataRow">
                <label class="form-label">ملاحظات اخرى (مترجمة):</label>
                <div class="form-control">{{ noticesEn }}</div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">حالة الإعلان: </label>
              <select class="form-control" v-model="status">
                <option :value="null">غير محدد</option>
                <option v-for="(val, key) in statusChoices" :value="key" :key="key">{{ val }}</option>
              </select>
            </div>
          </div>

        </div>
        <!-- images -->
        <div v-if="step == 3">
          <div class="row pb-3">
            <div class="col text-end">
              <button type="button" class="btn btn-success" data-bs-toggle="modal" data-bs-target="#uploadModal"><i class="bi bi-file-earmark-arrow-up"></i> إضافة صورة</button>
              <!-- Modal -->
              <div class="modal fade" id="uploadModal" tabindex="-1" aria-labelledby="uploadModalLabel" aria-hidden="true">
                <div class="modal-dialog">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h1 class="modal-title fs-5" id="uploadModalLabel">إضافة صورة</h1>
                      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                      <div class="row justify-content-center">
                        <div class="col-12 col-sm-8">
                          <input type="file" v-if="!mediaLoader" class="form-control" @change="uploadMedia($event.target.files)" multiple accept=".png,.jpg,.jpeg,.pmb,.webp">
                          <loader v-if="mediaLoader" />
                        </div>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">اغلاق</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-sm-3 media-img-container" v-for="(img, indx) in mediaList" :key="indx">
              <img :src="MEDIA_URL+img.path" class="img-thumbnail img-fluid" alt="">
              <button type="button" class="btn btn-danger btn-sm" @click="deleteMedia(img.id)"><i class="bi bi-trash"></i></button>
            </div>
          </div>
        </div>
      </div>
      <!--end::Body-->
      <!--begin::Footer-->
      <div class="card-footer">
        <div class="row">
          <div class="col text-start">
            <button v-if="step > 1" type="button" class="btn btn-secondary" @click="prevStep"><i class="bi bi-arrow-bar-right"></i> السابق</button>
          </div>
          <div class="col text-end">
            <button v-if="step < stepTitles.length" type="button" class="btn btn-secondary" @click="nextStep">التالي <i class="bi bi-arrow-bar-left"></i></button>
            <button v-if="step == stepTitles.length && !formLoader" type="submit" class="btn btn-success">ارسل</button>
            <loader v-if="step == stepTitles.length && formLoader" />
          </div>
        </div>
      </div>
      <!--end::Footer-->
    </form>
    <!--end::Form-->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { toast, shortDate } from '@/helpers/tools';
import $ from 'jquery';
window.$ = $;
window.jQuery = $;
import 'select2';
import 'select2/dist/css/select2.min.css';

export default {
  name: 'ExchangesForm',
  props: {
    cardTitle: {
      type: String,
      default: 'إضافة'
    },
    dataRow: {
      type: Object,
      default: null,
    },
  },
  data(){
    return {
      mainLoading: true,
      userLoader: false,
      mediaLoader: false,
      formLoader: false,
      rentalLoader: false,
      hasError: false,
      hasSucess: false,
      message: '',
      errorNumber: 0,
      step: 1,
      stepTitles: ["المالك", "بيانات التقبيل", "الصور"],
      // for config
      regionsList: [],
      ageList: [],
      weaknessList: [],
      strengthsList: [],
      assetsIdList: [],
      frontList: [],
      reasonList: [],
      businessList: [],
      userMobile: null,
      userName: null,
      uploadedReceipt: null,
      citiesList: [],
      neighborhoodsList: [],
      mediaList: [],
      createdBy: null,
      statusChoices: {},
      // fields
      userId: null,
      name: '',
      mobile: '',
      email: '',
      businessId: null,
      businessName: null,
      area: null,
      description: '',
      rentPrice: null,
      ageId: null,
      workersCount: null,
      reasonId: null,
      regionId: null,
      cityId: null,
      neighborhoodId: null,
      latitude: 24.7136,
      longitude: 46.6753,
      frontId: null,
      assetsList: '',
      assetId: null,
      hasDebts: false,
      debtsList: '',
      projectAgeId: null,
      officesCount: null,
      roomsCount: null,
      hallsCount: null,
      doorsCount: null,
      bathroomsCount: null,
      floorsCount: null,
      parkingCount: null,
      price: null,
      notices: '',
      status: null,
      mediaIds: [],
      weaknesses: [],
      strengths: [],
      map: null,
      marker: null,
      businessOther: null,
      assetsListEn: '',
      debtsListEn: '',
      noticesEn: '',
      descriptionEn: '',
    }
  },
  computed:{
    ...mapGetters(['MEDIA_URL', 'GOOGLE_MAP_API'])
  },
  methods: {
    prevStep(){
      this.step = this.step - 1;
      if(this.step == 2){
        this.initialGoogleMap();
        this.initSearchableSelects();
      }
    },
    nextStep(){
      this.hasError = false;
      this.errorNumber = 0;
      if(this.step == 1){
        if(!this.userId){
          this.message = 'يجب اختيار العميل';
          this.hasError = true;
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return false;
        }
        if(!this.name || this.name.trim() == ''){
          this.message = 'يجب ادخال الاسم';
          this.hasError = true;
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return false;
        }
        if(!this.mobile || this.mobile.trim() == ''){
          this.message = 'يجب ادخال رقم الجوال';
          this.hasError = true;
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return false;
        }
      }
      if(this.step == 2){
        if(!this.businessId){
          this.message = 'يجب اختيار نوع النشاط التجاري';
          this.hasError = true;
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return false;
        }
        if((!this.businessName || `${this.businessName}`.trim() == '') && this.businessOther && this.businessOther.id == this.businessId){
          this.message = 'يجب كتابة اسم النشاط التجاري';
          this.hasError = true;
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return false;
        }
        if(!this.description || this.description.trim() == ''){
          this.message = 'يجب كتابة وصف النشاط';
          this.hasError = true;
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return false;
        }
        if(!this.ageId){
          this.message = 'يجب اختيار مدة الإيجار المتبقية';
          this.hasError = true;
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return false;
        }
        if(!this.reasonId){
          this.message = 'يجب اختيار سبب التقبيل';
          this.hasError = true;
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return false;
        }
        if(!this.regionId){
          this.message = 'يجب اختيار المنطقة';
          this.hasError = true;
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return false;
        }
        if(!this.cityId){
          this.message = 'يجب اختيار المدينة';
          this.hasError = true;
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return false;
        }
        if(!this.neighborhoodId){
          this.message = 'يجب اختيار الحي';
          this.hasError = true;
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return false;
        }
        if(!this.frontId){
          this.message = 'يجب اختيار الوجهه';
          this.hasError = true;
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return false;
        }
        if(!this.projectAgeId){
          this.message = 'يجب اختيار عمر المشروع';
          this.hasError = true;
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return false;
        }
        if(!this.status){
          this.message = 'يجب اختيار حالة الإعلان';
          this.hasError = true;
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return false;
        }
      }
      this.step = this.step + 1;
      if(this.step == 2){
        this.initialGoogleMap();
        this.initSearchableSelects();
      }
    },
    getInitData(){
      this.$http.get('/api/admin/exchanges/init').then(({data}) => {
        this.regionsList = data.regionsList;
        this.ageList = data.agesList;
        this.reasonList = data.reasonsList;
        this.businessList = data.businessList;
        this.frontList = data.frontsList;
        this.assetsIdList = data.assetsList;
        this.strengthsList = data.strengthsList;
        this.weaknessList = data.weaknessList;
        this.statusChoices = data.statusChoices;
        this.businessOther = data.businessOther ?? null;
        this.mainLoading = false;
        this.initSearchableSelects();
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
    getClientData(){
      if(this.userMobile && this.userMobile.length >= 10){
        this.hasError = false;
        this.hasSucess = false;
        this.userLoader = true;
        this.userId = null;
        this.userName = null;
        this.$http.post('/api/admin/users/getUser', {
          mobile: this.userMobile.trim(),
        }).then(({data}) => {
          this.userId = data.user.id;
          this.userName = data.user.name;
          this.userLoader = false;
        }).catch(err => {
          [this.message, this.errorNumber] = this.$globalError(err, true);
          this.hasError = true;
          this.userLoader = false;
          // window.scrollTo({ top: 0, behavior: 'smooth' });
        });
      }
    },
    getCitiesList(change=true){
      this.hasError = false;
      this.citiesList = [];
      this.neighborhoodsList = [];
      if(change){
        this.cityId = null;
        this.neighborhoodId = null;
      }
      if(!this.regionId){
        return;
      }
      this.$http.get(`/api/admin/cities/list?regionId=${this.regionId}&all=1`).then(({data}) => {
        this.citiesList = data.cities;
        this.initSelect2('citySelect', 'cityId', () => this.getNeighborhoodsList());
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
    getNeighborhoodsList(change=true){
      this.hasError = false;
      this.neighborhoodsList = [];
      if(change)
        this.neighborhoodId = null;
      if(!this.cityId){
        return;
      }
      this.$http.get(`/api/admin/neighborhoods/list?cityId=${this.cityId}&all=1`).then(({data}) => {
        this.neighborhoodsList = data.neighborhoods;
        this.initSelect2('neighborhoodSelect', 'neighborhoodId');
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
    async uploadMedia(files){
      this.mediaLoader = true;
      for(let i=0; i<files.length; i++){
        const formData = new FormData();
        formData.append('file', files[i]);
        try {
          const mFile = await this.$http.post('/api/admin/exchanges/media/upload', formData);
          if(mFile){
            this.mediaIds.push(mFile.data.mediaId);
            this.mediaList.push({
              id: mFile.data.mediaId,
              path: mFile.data.filePath,
            });
          }
        }catch(err){
          // console.log(err);
        }
      }
      this.mediaLoader = false;
      toast('تم رفع الصور بنجاح', 'success');
    },
    deleteMedia(id){
      this.$swal.fire({
        title: "هل تريد تأكيد حذف الصورة؟",
        showCancelButton: true,
        confirmButtonText: "حذف",
        cancelButtonText: "إلغاء",
        confirmButtonColor: '#dc3741',
      }).then((result) => {
        if (result.isConfirmed) {
          this.$http.delete(`/api/admin/exchanges/media/delete/${id}`).then(({data}) => {
            this.mediaIds.splice(this.mediaIds.indexOf(id), 1);
            let mediaArray = [];
            this.mediaList.map(m => {
              if(m.id != id)
                mediaArray.push(m);
            });
            this.mediaList = mediaArray;
            toast('تم حذف الصورة بنجاح', 'success');
          }).catch(err => {
            toast('غير قادر على حذف الصورة');
          });
        }
      });
    },
    subimtData(){
      this.formLoader = true;
      this.hasError = false;
      this.hasSucess = false;
      let payload = {
        userId: this.userId,
        name: this.name,
        mobile: this.mobile,
        email: this.email,
        businessId: this.businessId,
        businessName: this.businessName,
        area: this.area,
        description: this.description,
        rentPrice: this.rentPrice,
        ageId: this.ageId,
        workersCount: this.workersCount,
        reasonId: this.reasonId,
        regionId: this.regionId,
        cityId: this.cityId,
        neighborhoodId: this.neighborhoodId,
        latitude: this.latitude,
        longitude: this.longitude,
        frontId: this.frontId,
        assetsList: this.assetsList,
        assetId: this.assetId,
        hasDebts: this.hasDebts,
        debtsList: this.debtsList,
        projectAgeId: this.projectAgeId,
        officesCount: this.officesCount,
        roomsCount: this.roomsCount,
        hallsCount: this.hallsCount,
        doorsCount: this.doorsCount,
        bathroomsCount: this.bathroomsCount,
        floorsCount: this.floorsCount,
        parkingCount: this.parkingCount,
        price: this.price,
        notices: this.notices,
        status: this.status,
        mediaIds: this.mediaIds,
        weaknesses: this.weaknesses,
        strengths: this.strengths,
      };
      
      let api = null;
      if(this.dataRow)
        api = this.$http.put(`/api/admin/exchanges/update/${this.dataRow.id}`, payload);
      else
        api = this.$http.post('/api/admin/exchanges/create', payload);
      api.then(({data}) => {
        if(!this.dataRow){
          toast('تم إضافة الإعلان بنجاح', 'success');
          this.$router.replace('/exchanges').catch(() => {});
        }else{
          this.message = 'تم التعديل بنجاح';
          this.hasSucess = true;
          this.step = 1;
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
        this.formLoader = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.formLoader = false;
      });
    },
    // google map 
    initMap(){
      if (!this.$refs.myMap) {
        setTimeout(() => this.initMap(), 200);
        return;
      }
      if (!window.google) {
        console.error("Google Maps API is not loaded.");
        return;
      }

      // Initialize Map
      this.map = new google.maps.Map(this.$refs.myMap, {
        center: { lat: this.latitude ?? 24.7136, lng: this.longitude ?? 46.6753 },
        zoom: 8,
      });

      // Create a Marker
      this.marker = new google.maps.Marker({
        position: { lat: this.latitude ?? 24.7136, lng: this.longitude ?? 46.6753 },
        map: this.map,
        draggable: true, // Allow dragging the marker
      });

      // Update lat/lng when marker is moved
      this.marker.addListener("dragend", () => {
        const pos = this.marker.getPosition();
        this.latitude = pos.lat();
        this.longitude = pos.lng();
      });

      // Click on the map to set a new marker position
      this.map.addListener("click", (event) => {
        this.latitude = event.latLng.lat();
        this.longitude = event.latLng.lng();
        this.marker.setPosition(event.latLng);
      });
    },
    initialGoogleMap(){
      if (!window.google) {
        const script = document.createElement("script");
        script.src = `https://maps.googleapis.com/maps/api/js?key=${this.GOOGLE_MAP_API}&loading=async&libraries=places&callback=initMap`;
        script.async = true;
        document.head.appendChild(script);
        window.initMap = this.initMap;
      } else {
        this.initMap();
      }
    },
    changeMarker(){
      const newPosition = new google.maps.LatLng(this.latitude, this.longitude);
      this.marker.setPosition(newPosition);
      this.map.setCenter(newPosition);
    },
    jumbToStep(stepNum){
      if(this.dataRow){
        this.step = stepNum;
        if(stepNum == 2){
          this.initialGoogleMap();
          this.initSearchableSelects();
        }
      }
    },
    initSelect2(refName, field, onChangeCallback = null){
      this.$nextTick(() => {
        const el = this.$refs[refName];
        if(!el) return;
        const $el = $(el);
        if($el.hasClass('select2-hidden-accessible')){
          $el.select2('destroy');
        }
        $el.select2({
          dir: 'rtl',
          width: '100%',
          placeholder: 'ابحث واختر...',
        });
        $el.off('change.vueSelect2').on('change.vueSelect2', () => {
          const val = $el.val();
          if(val === null || val === ''){
            this[field] = null;
          }else{
            this[field] = isNaN(val) ? val : Number(val);
          }
          if(typeof onChangeCallback === 'function'){
            onChangeCallback();
          }
        });
      });
    },
    initSearchableSelects(){
      this.$nextTick(() => {
        this.initSelect2('businessSelect', 'businessId');
        this.initSelect2('ageSelect', 'ageId');
        this.initSelect2('reasonSelect', 'reasonId');
        this.initSelect2('citySelect', 'cityId', () => this.getNeighborhoodsList());
        this.initSelect2('neighborhoodSelect', 'neighborhoodId');
        this.initSelect2('frontSelect', 'frontId');
        this.initSelect2('projectAgeSelect', 'projectAgeId');
      });
    },
  },
  created(){
    if(this.dataRow){
      // for config
      if(this.dataRow.ExchangeMedia){
        this.dataRow.ExchangeMedia.map(m => {
          this.mediaList.push({
            id: m.id,
            path: m.filePath,
          });
          this.mediaIds.push(m.id);
        });
      }
      this.userMobile = this.dataRow.User.mobile;
      this.userName = this.dataRow.User.name;
      this.userId = this.dataRow.userId;
      this.name = this.dataRow.name;
      this.mobile = this.dataRow.mobile;
      this.email = this.dataRow.email;
      this.businessId = this.dataRow.businessId;
      this.businessName = this.dataRow.businessName;
      this.area = this.dataRow.area;
      this.description = this.dataRow.description;
      this.rentPrice = this.dataRow.rentPrice;
      this.ageId = this.dataRow.ageId;
      this.workersCount = this.dataRow.workersCount;
      this.reasonId = this.dataRow.reasonId;
      this.regionId = this.dataRow.regionId;
      this.cityId = this.dataRow.cityId;
      this.neighborhoodId = this.dataRow.neighborhoodId;
      this.latitude = (this.dataRow.latitude)? parseFloat(this.dataRow.latitude) : null;
      this.longitude = (this.dataRow.longitude)? parseFloat(this.dataRow.longitude) : null;
      this.frontId = this.dataRow.frontId;
      this.assetsList = this.dataRow.assetsList;
      this.assetId = this.dataRow.assetId;
      this.hasDebts = this.dataRow.hasDebts;
      this.debtsList = this.dataRow.debtsList;
      this.projectAgeId = this.dataRow.projectAgeId;
      this.officesCount = this.dataRow.officesCount;
      this.roomsCount = this.dataRow.roomsCount;
      this.hallsCount = this.dataRow.hallsCount;
      this.doorsCount = this.dataRow.doorsCount;
      this.bathroomsCount = this.dataRow.bathroomsCount;
      this.floorsCount = this.dataRow.floorsCount;
      this.parkingCount = this.dataRow.parkingCount;
      this.price = this.dataRow.price;
      this.notices = this.dataRow.notices;
      this.status = this.dataRow.status;
      this.assetsListEn = this.dataRow.assetsListEn;
      this.debtsListEn = this.dataRow.debtsListEn;
      this.noticesEn = this.dataRow.noticesEn;
      this.descriptionEn = this.dataRow.descriptionEn;
      if(this.dataRow.ExchangeStrengths){
        this.dataRow.ExchangeStrengths.map(f => {
          this.strengths.push(f.id);
        })
      }
      if(this.dataRow.ExchangeWeaknesses){
        this.dataRow.ExchangeWeaknesses.map(f => {
          this.weaknesses.push(f.id);
        })
      }
      this.getCitiesList(false);
      this.getNeighborhoodsList(false);
    }

    this.getInitData();
  }
}
</script>

<style scoped>
.steps-container {
  margin-bottom: 40px;
}
.steps {
  display: flex;
  justify-content: space-around;
  white-space: nowrap;
  font-weight: bold;
  cursor: pointer;
}

.steps span {
  padding: 5px 15px;
  border-bottom: 3px solid #ccc;
}

.steps .active {
  color: #007bff;
  border-bottom: 3px solid #007bff;
}
</style>
